import {GetterTree} from 'vuex'
import {ICompaniesStateModel, IRootStateModel} from './../../../interfaces'
import {CompanyModel, CompaniesListSortModel, CompaniesListFilterModel} from '@/services/types'

export type CompaniesGetters = {
    getCompaniesList(state: ICompaniesStateModel): CompanyModel [];
    getCompaniesListPage(state: ICompaniesStateModel): number;
    getCompaniesListPerPage(state: ICompaniesStateModel): number;
    getCompaniesTotal(state: ICompaniesStateModel): number;
    isCompaniesDataLoading(state: ICompaniesStateModel): boolean;
    getCompaniesSortValue(state: ICompaniesStateModel): CompaniesListSortModel;
    getCompaniesFilterValue(state: ICompaniesStateModel): CompaniesListFilterModel;
    getCompaniesSelectedCompany(state: ICompaniesStateModel): CompanyModel;
}

export const getters: GetterTree<ICompaniesStateModel, IRootStateModel> & CompaniesGetters = {
    getCompaniesList: (state: ICompaniesStateModel) => {
        return state.list
    },
    getCompaniesListPage: (state: ICompaniesStateModel) => {
        return state.page
    },
    getCompaniesListPerPage: (state: ICompaniesStateModel) => {
        return state.perPage
    },
    getCompaniesTotal: (state: ICompaniesStateModel) => {
        return state.total
    },
    isCompaniesDataLoading: (state: ICompaniesStateModel) => {
        return state.dataIsLoading
    },
    getCompaniesFilterValue: (state: ICompaniesStateModel) => {
        return state.filter
    },
    getCompaniesSortValue: (state: ICompaniesStateModel) => {
        return state.sort
    },
    getCompaniesSelectedCompany: (state: ICompaniesStateModel) => {
        return state.selectedCompany
    }
}